import { router, usePage } from "@inertiajs/react";
import { X } from "lucide-react";
import { Badge } from "@/components/ui/badge.jsx";
import { Button } from "@/components/ui/button.jsx";

export default function ActiveFilters() {
  if (import.meta.env.SSR) return null;

  const { filters, taxon } = usePage().props;
  const params = new URLSearchParams(document.location.search);

  const chips = [];

  const query = params.get("q");
  if (query) {
    chips.push({ key: "q", label: "Поиск", value: query });
  }

  const price = params.get("filter[price]");
  if (price) {
    const [min, max] = price.split(",");
    chips.push({ key: "filter[price]", label: "Цена", value: [min, max].join(" – ") });
  }

  const taxonsParam = params.get("filter[taxons]");
  if (taxonsParam) {
    const namesById = (taxon?.children || []).reduce(
      (acc, child) => ({ ...acc, [child.id]: child.name }),
      {}
    );
    const value = taxonsParam
      .split(",")
      .map((id) => namesById[id] || id)
      .join(", ");
    chips.push({ key: "filter[taxons]", label: "Категории", value });
  }

  const productProperties = filters?.product_properties || [];

  const propertyValuesByParam = {};
  productProperties.forEach((productProperty) => {
    (productProperty.values || []).forEach((option) => {
      propertyValuesByParam[option.filter_param] = option.presentation || option.value;
    });
  });

  [...params.entries()].forEach(([key, value]) => {
    const match = key.match(/^filter\[properties\]\[(.+)\]$/);
    if (!match || value.length === 0) return;

    const presentation = productProperties.find(
      (productProperty) => productProperty.name === match[1]
    )?.presentation;
    const formattedValue = value
      .split(",")
      .map((entry) => propertyValuesByParam[entry] || entry)
      .join(", ");

    chips.push({
      key,
      label: presentation || match[1],
      value: formattedValue,
    });
  });

  if (chips.length === 0) return null;

  const navigate = (paramsString) => {
    router.visit(`?${paramsString}`, { except: ["filters"] });
  };

  const removeFilter = (key) => {
    const next = new URLSearchParams(document.location.search);
    next.delete(key);
    next.delete("page");
    navigate(next.toString());
  };

  const resetAll = () => {
    const next = new URLSearchParams(document.location.search);
    [...next.keys()].forEach((key) => {
      if (key === "q" || key.startsWith("filter[")) {
        next.delete(key);
      }
    });
    next.delete("page");
    navigate(next.toString());
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm text-gray-500">Активные фильтры:</span>
      {chips.map((chip) => (
        <Badge key={chip.key} variant="secondary" className="pr-1">
          <span>
            {chip.label}: {chip.value}
          </span>
          <button
            type="button"
            aria-label={`Убрать фильтр «${chip.label}»`}
            className="rounded-full p-0.5 hover:bg-gray-200"
            onClick={() => removeFilter(chip.key)}
          >
            <X className="size-3" />
          </button>
        </Badge>
      ))}
      <Button
        variant="link"
        size="sm"
        className="h-auto px-1"
        onClick={resetAll}
      >
        Сбросить все
      </Button>
    </div>
  );
}